import { html, css, LitElement, nothing } from 'lit';
import { ifDefined } from 'lit-html/directives/if-defined';

import '@material/web/textfield/filled-text-field.js';

export class WindhagerScheduleSwitchPoint extends LitElement {

    // internal reactive states
    static get properties() {
        return {
						time: { state: false },
						temperature: { state: false },
            disableAdd: { state: false },
            disableRemove: { state: false },
        };
    }

	render() {
		let hours = this.time.split(":")[0];
		let minutes = this.time.split(":")[1];

		return html`
			<div class="switchpoint">
				<div class="switchpoint-time">
					<md-filled-text-field class="hours hasSuffix" type="text" inputmode="numeric" required value="${hours}" suffix-text=":" @change=${this.hoursChanged}>
					</md-filled-text-field><md-filled-text-field class="minutes" type="text" inputmode="numeric" required value="${minutes}" @change=${this.minutesChanged}></md-filled-text-field>
				</div>
					<md-filled-text-field class="hasSuffix temperature" type="number" inputmode="decimal" min="6" max="30" step=".5" required value="${this.temperature}" suffix-text="°C" @change=${this.temperatureChanged}></md-filled-text-field>
					<mwc-button class="switchpoint-button" @click="${() => {this.parent.removeSwitchPoint(this.index)}}" disabled=${ifDefined(this.disableRemove ? '' : undefined)}>
						<ha-icon icon="mdi:minus-circle-outline"></ha-icon>
					</mwc-button>
					<mwc-button class="switchpoint-button" @click="${() => {this.parent.addSwitchPoint()}}" disabled=${ifDefined(this.disableAdd ? '' : undefined)}>
						<ha-icon icon="mdi:plus-circle-outline"></ha-icon>
					</mwc-button>
			</div>
		`;
	}

	hoursChanged(event) {
		const input = event.target;
		const parsed = Number.parseInt(input.value);
		if (Number.isNaN(parsed)) {
			return;
		}
		if (parsed >= 0 && parsed <= 23) {
			let minutes = this.time.split(":")[1];
			let hours = (parsed > 9) ? parsed : "0" + parsed;
			let newtime = hours + ":" + minutes;
			this.time = newtime;

			this.dispatchEvent(new CustomEvent("sp-changed", {
				bubbles: true,
				detail: { "time": this.time, "value": this.temperature, "index": this.index }
			}));
		}
	}

	minutesChanged(event) {
		const input = event.target;
		const parsed = Number.parseInt(input.value);
		if (Number.isNaN(parsed)) {
			return;
		}
		if (parsed >= 0 && parsed <= 59) {
			let hours = this.time.split(":")[0];
			let minutes = (Math.round(parsed / 15.0) * 15) % 60;
			minutes = (minutes > 9) ? minutes : "0" + minutes;
			let newtime = hours + ":" + minutes;
			this.time = newtime;
			
			this.dispatchEvent(new CustomEvent("sp-changed", {
				bubbles: true,
				detail: { "time": this.time, "value": this.temperature, "index": this.index }
			}));
		}
	}

	temperatureChanged(event) {
		const input = event.target;
		const parsed = Number.parseFloat(input.value);
		if (Number.isNaN(parsed)) {
			return;
		}
		this.temperature = parsed;
					
		this.dispatchEvent(new CustomEvent("sp-changed", {
			bubbles: true,
			detail: { "time": this.time, "value": this.temperature, "index": this.index }
		}));
	}


	static styles = css`
		.switchpoint {
			display: flex;
			flex-wrap: wrap;
			justify-content: end;
			margin: 8px 0px 8px 8px;
			align-items: center;
		}
		.switchpoint-time {
			flex-grow: 3;
		}
		md-filled-text-field.hours, md-filled-text-field.minutes {
			width: 40px;
			text-align: center;
			--mdc-shape-small: 0;
		  --md-filled-text-field-container-shape: 0px;
			--md-filled-text-field-trailing-space: 0px;
			--md-filled-text-field-leading-space: 0px;
			--text-field-appearance: none;
			--text-field-padding: 0 4px;
			--text-field-suffix-padding-left: 2px;
			--text-field-suffix-padding-right: 0;
			--text-field-text-align: center;
		}
		md-filled-text-field.temperature {
			width: 120px;
		}
		.switchpoint-button {
			vertical-align: middle;
		}
	`;
}
customElements.define('windhager-schedule-switchpoint', WindhagerScheduleSwitchPoint);
